module.exports = __webpack_public_path__ + "img/logo-text_sollers.cde7b270.svg";